import { render } from "./RegisterContest.vue?vue&type=template&id=6960be70"
import script from "./RegisterContest.vue?vue&type=script&lang=js"
export * from "./RegisterContest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__